(function ($) {
  'use strict';

  window.ys.Strava2023 = new Strava2023();
  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('strava_2023')) {
    window.ys.Strava2023Contest = new Strava2023.Contest();
  }
}).bind(window)(jQuery);
